import { CALL_API, Schemas } from '../../../common/middleware/api';
import globalize from '../../../common/services/globalize';
import moment from 'moment';

export const CANCELLATION_CREDIT_NOTES_REPORT_REQUEST = 'CANCELLATION_CREDIT_NOTES_REPORT_REQUEST';
export const CANCELLATION_CREDIT_NOTES_REPORT_SUCCESS = 'CANCELLATION_CREDIT_NOTES_REPORT_SUCCESS';
export const CANCELLATION_CREDIT_NOTES_REPORT_FAILURE = 'CANCELLATION_CREDIT_NOTES_REPORT_FAILURE';

export const CANCELLATION_CREDIT_NOTES_EXPORT_REQUEST = 'CANCELLATION_CREDIT_NOTES_EXPORT_REQUEST';
export const CANCELLATION_CREDIT_NOTES_EXPORT_SUCCESS = 'CANCELLATION_CREDIT_NOTES_EXPORT_SUCCESS';
export const CANCELLATION_CREDIT_NOTES_EXPORT_FAILURE = 'CANCELLATION_CREDIT_NOTES_EXPORT_FAILURE';

export const loadCancellationCreditNotesReport = (options) => ({
	[CALL_API]: {
		types: [CANCELLATION_CREDIT_NOTES_REPORT_REQUEST, CANCELLATION_CREDIT_NOTES_REPORT_SUCCESS, CANCELLATION_CREDIT_NOTES_REPORT_FAILURE],
		endpoint: `api/reports/cancellationCreditNotes`,
		request: options,
		schema: Schemas.CANCELLATION_CREDIT_NOTES_REPORT_ARRAY
	}
});

export const exportCancellationCreditNotes = (exportFormat, options, onSuccessEvent) => (dispatch, getState) => {
	dispatch({
		[CALL_API]: {
			types: [CANCELLATION_CREDIT_NOTES_EXPORT_REQUEST, CANCELLATION_CREDIT_NOTES_EXPORT_SUCCESS, CANCELLATION_CREDIT_NOTES_EXPORT_FAILURE],
			endpoint: `api/reports/cancellationCreditNotes/export/${exportFormat === 'Xero' ? 'xero' : ''}`,
			request: {
				...options,
				timeZone: globalize.getCurrentTimeZone(getState().configuration.franchisor)
			},
			onSuccessEvent
		},
		format: exportFormat,
		filename: () => `CancellationCreditNotes-${moment().format('YYYY-MM-DD')}.${exportFormat === 'Xero' ? 'csv' : 'xlsx'}`
	});
}